import { AxiosError } from 'axios';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { useApiClient } from '@/providers/ApiClientProvider';
import type { IError } from '@/api/http';
import API from '@/lib/API';
import { queryClient } from '@/lib/query-client';

import type { ResEnable2FADTO } from '../my-profile.types';

export const useEnable2FAMutation = (
  options?: UseMutationOptions<ResEnable2FADTO, AxiosError<IError>>,
) => {
  const { httpWithAuth, api } = useApiClient();

  return useMutation({
    mutationFn: async (): Promise<ResEnable2FADTO> => {
      return await api<ResEnable2FADTO>(httpWithAuth.post(API.enable2FA));
    },
    ...options,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['profile'], exact: true });
    },
  });
};
